/**
 * Moduli Mantra ufficiali — Edizione 2026/2027 (Mantra Experience).
 * Ogni slot è l'insieme dei ruoli accettati (slash ufficiale → array).
 * Ordine array: P → difesa (sx→dx in campo con attacco in alto) → centrocampo → attacco.
 * Per le difese a 4: DS a sinistra, DD a destra (convenzione campo).
 */

export const MANTRA_MODULE_IDS = [
  '3-4-3',
  '3-4-1-2',
  '3-4-2-1',
  '3-5-2',
  '3-5-1-1',
  '4-3-3',
  '4-3-1-2',
  '4-4-2',
  '4-1-4-1',
  '4-4-1-1',
  '4-2-3-1',
];

export const MANTRA_MODULES = {
  '3-4-3': [
    ['P'],
    ['DC'],
    ['DC'],
    ['DC', 'B'],
    ['E'],
    ['M', 'C'],
    ['C'],
    ['E'],
    ['W', 'A'],
    ['A', 'PC'],
    ['W', 'A'],
  ],
  '3-4-1-2': [
    ['P'],
    ['DC'],
    ['DC'],
    ['DC', 'B'],
    ['E'],
    ['M', 'C'],
    ['C'],
    ['E'],
    ['T'],
    ['A', 'PC'],
    ['A', 'PC'],
  ],
  '3-4-2-1': [
    ['P'],
    ['DC'],
    ['DC'],
    ['DC', 'B'],
    ['E', 'W'],
    ['M'],
    ['M', 'C'],
    ['E'],
    ['T'],
    ['T', 'A'],
    ['A', 'PC'],
  ],
  '3-5-2': [
    ['P'],
    ['DC'],
    ['DC'],
    ['DC', 'B'],
    ['E', 'W'],
    ['M', 'C'],
    ['M'],
    ['C'],
    ['E'],
    ['A', 'PC'],
    ['A', 'PC'],
  ],
  '3-5-1-1': [
    ['P'],
    ['DC'],
    ['DC'],
    ['DC', 'B'],
    ['E', 'W'],
    ['M'],
    ['C'],
    ['M'],
    ['E', 'W'],
    ['T', 'A'],
    ['A', 'PC'],
  ],
  '4-3-3': [
    ['P'],
    ['DS'],
    ['DC'],
    ['DC'],
    ['DD'],
    ['M', 'C'],
    ['M'],
    ['C'],
    ['W', 'A'],
    ['A', 'PC'],
    ['W', 'A'],
  ],
  '4-3-1-2': [
    ['P'],
    ['DS'],
    ['DC'],
    ['DC'],
    ['DD'],
    ['M', 'C'],
    ['M'],
    ['C'],
    ['T'],
    ['T', 'A', 'PC'],
    ['A', 'PC'],
  ],
  '4-4-2': [
    ['P'],
    ['DS'],
    ['DC'],
    ['DC'],
    ['DD'],
    ['E', 'W'],
    ['M', 'C'],
    ['C'],
    ['E'],
    ['A', 'PC'],
    ['A', 'PC'],
  ],
  '4-1-4-1': [
    ['P'],
    ['DS'],
    ['DC'],
    ['DC'],
    ['DD'],
    ['M'],
    ['E', 'W'],
    ['C', 'T'],
    ['T'],
    ['W'],
    ['A', 'PC'],
  ],
  '4-4-1-1': [
    ['P'],
    ['DS'],
    ['DC'],
    ['DC'],
    ['DD'],
    ['E', 'W'],
    ['M'],
    ['C'],
    ['E', 'W'],
    ['T', 'A'],
    ['A', 'PC'],
  ],
  '4-2-3-1': [
    ['P'],
    ['DS'],
    ['DC'],
    ['DC'],
    ['DD'],
    ['M'],
    ['M', 'C'],
    ['W', 'T'],
    ['T'],
    ['W', 'A'],
    ['A', 'PC'],
  ],
};

/**
 * Lunghezze linee in ordine array slot (P → … → attacco).
 * Il renderer inverte le linee per mettere l'attacco in alto.
 */
export const MANTRA_MODULE_LINES = {
  '3-4-3': [1, 3, 4, 3],
  '3-4-1-2': [1, 3, 4, 1, 2],
  '3-4-2-1': [1, 3, 4, 2, 1],
  '3-5-2': [1, 3, 5, 2],
  '3-5-1-1': [1, 3, 5, 1, 1],
  '4-3-3': [1, 4, 3, 3],
  '4-3-1-2': [1, 4, 3, 1, 2],
  '4-4-2': [1, 4, 4, 2],
  '4-1-4-1': [1, 4, 1, 4, 1],
  '4-4-1-1': [1, 4, 4, 1, 1],
  '4-2-3-1': [1, 4, 2, 3, 1],
};
